// Tabs — segmented control en pill, activo con bg-ink.

export default function Tabs({ items, value, onChange, className = '' }) {
  return (
    <div
      role="tablist"
      className={`inline-flex items-center gap-0.5 p-1 rounded-pill border border-[var(--line)] bg-[var(--bg)] ${className}`}
    >
      {items.map(it => {
        const active = value === it.value
        return (
          <button
            key={it.value}
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(it.value)}
            className={`px-3.5 py-1.5 rounded-pill text-[12.5px] font-medium transition-colors ${
              active ? 'bg-[var(--ink)] text-[var(--bg)]' : 'text-[var(--ink-2)] hover:text-[var(--ink)]'
            }`}
          >
            {it.label}
          </button>
        )
      })}
    </div>
  )
}
